import { Table } from 'antd';

const TopProductDesktop = ({ viewModel }) => {
  const { columns, dataSource } = viewModel;

  return <Table columns={columns} dataSource={dataSource} rowKey={(record) => record?.id || record?.product?.id} />;
};

export default TopProductDesktop;
